import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { HexBadgeModule } from "@hex/angular/badge";
import { HexButtonModule } from "@hex/angular/button";
import { HexButtonBarModule } from "@hex/angular/button-bar";
import { HexButtonGroupModule } from "@hex/angular/button-group";
import { HexCheckboxModule } from "@hex/angular/checkbox";
import { HexControlsModule } from "@hex/angular/controls";
import { HexCounterModule } from "@hex/angular/counter";
import { HexDatefieldModule } from "@hex/angular/datefield";
import { HexDropdownModule } from "@hex/angular/dropdown";
import { HexFieldHintModule } from "@hex/angular/field-hint";
import { HexFieldLabelModule } from "@hex/angular/field-label";
import { HexFlyInModule } from "@hex/angular/fly-in";
import { HexFormfieldModule } from "@hex/angular/formfield";
import { HexIconModule } from "@hex/angular/icon";
import { HexLinkModule } from "@hex/angular/link";
import { HexListModule } from "@hex/angular/list";
import { HexModalScreenModule } from "@hex/angular/modal-screen";
import { HexNotificationModule } from "@hex/angular/notification";
import { HexPanelModule } from "@hex/angular/panel";
import { HexPillModule } from "@hex/angular/pill";
import { HexRadioModule } from "@hex/angular/radio";
import { HexRuleModule } from "@hex/angular/rule";
import { HexSelectfieldModule } from "@hex/angular/selectfield";
import { HexSwitchModule } from "@hex/angular/switch";
import { HexTabsModule } from "@hex/angular/tabs";
import { HexTagModule } from "@hex/angular/tag";
import { HexTextModule } from "@hex/angular/text";
import { HexTextfieldModule } from "@hex/angular/textfield";
import { HexTooltipModule } from "@hex/angular/tooltip";
import { HexTypeaheadModule } from "@hex/angular/typeahead";

import { SharedPipesModule } from "../../pipes";

import { DownloadLinkModule } from "../download-link/download-link.module";
import { ModifiersModule } from "../presentational/modifiers/modifiers.module";
import { OverridesModule } from "../presentational/overrides/overrides.module";
import { SectionsModule } from "../presentational/sections/sections.module";
import { TextPatternsModule } from "../presentational/text-patterns/text-patterns.module";
import { CalculatedHeightDirective } from "./calculated-height.directive";
import {
    TriggerBindingDirective,
    TriggerWhenDestroyedDirective,
    TriggerWhenReadyDirective,
} from "./common-triggers.directive";
import { ImmutableTemplateOutletDirective } from "./immutable-template-outlet.directive";
import { KeystrokeDebounceDirective } from "./keystroke-debounce.directive";

const bundledModules = [
    HexButtonModule,
    HexButtonGroupModule,
    HexButtonBarModule,
    HexCheckboxModule,
    HexControlsModule,
    HexCounterModule,
    HexIconModule,
    HexBadgeModule,
    HexDatefieldModule,
    HexDropdownModule,
    HexFormfieldModule,
    HexFieldHintModule,
    HexFieldLabelModule,
    HexFlyInModule,
    HexModalScreenModule,
    HexTextfieldModule,
    HexSelectfieldModule,
    HexLinkModule,
    HexListModule,
    HexNotificationModule,
    HexPanelModule,
    HexPillModule,
    HexRadioModule,
    HexRuleModule,
    HexSwitchModule,
    HexTabsModule,
    HexTagModule,
    HexTextModule,
    HexTooltipModule,
    HexTypeaheadModule,
    DownloadLinkModule,
    ModifiersModule,
    OverridesModule,
    SectionsModule,
    TextPatternsModule,
    SharedPipesModule,
];

@NgModule({
    imports: [
        CommonModule,
        ...bundledModules,
    ],
    exports: [
        ...[
            CalculatedHeightDirective,
            KeystrokeDebounceDirective,
            ImmutableTemplateOutletDirective,
            TriggerBindingDirective,
            TriggerWhenReadyDirective,
            TriggerWhenDestroyedDirective,
        ],
        ...bundledModules,
    ],
    declarations: [
        CalculatedHeightDirective,
        KeystrokeDebounceDirective,
        ImmutableTemplateOutletDirective,
        TriggerBindingDirective,
        TriggerWhenReadyDirective,
        TriggerWhenDestroyedDirective,
    ],
    providers: [],
})
export class CommonUtilsModule {
}
